import React from 'react';

const UserIds = ({ value }) => {
    if (!Array.isArray(value) || value.length === 0) {
        return <span>-</span>;
    }

    return <span>{value.join(', ')}</span>;
};

export default UserIds;
